import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Controller ist verbunden
  }

  switchTab(event) {
    const clickedTab = event.currentTarget
    const targetTab = clickedTab.dataset.tab

    // Alle Tab-Buttons zurücksetzen
    this.element.querySelectorAll('.tab-button').forEach(button => {
      button.classList.remove('border-blue-500', 'text-blue-600')
      button.classList.add('border-transparent', 'text-gray-500')
    })

    // Alle Tab-Panels ausblenden
    this.element.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.add('hidden')
      panel.classList.remove('active')
    })

    // Klicked Tab aktivieren
    clickedTab.classList.remove('border-transparent', 'text-gray-500')
    clickedTab.classList.add('border-blue-500', 'text-blue-600')

    // Entsprechendes Panel anzeigen
    const targetPanel = this.element.querySelector(`.tab-panel[data-tab="${targetTab}"]`)
    if (targetPanel) {
      targetPanel.classList.remove('hidden')
      targetPanel.classList.add('active')
      
      // Lade Turbo Frame für Einsatzhistorie Tab
      if (targetTab === 'history') {
        const turboFrame = targetPanel.querySelector('turbo-frame')
        if (turboFrame && !turboFrame.src) {
          // Setze src nur wenn noch nicht gesetzt
          const applicantId = this.element.closest('[data-applicant-id]')?.dataset.applicantId
          if (applicantId) {
            // Verwende den korrekten Pfad basierend auf der aktuellen URL
            const currentPath = window.location.pathname
            const locale = currentPath.split('/')[1] || 'de'
            turboFrame.src = `/${locale}/backend/experiences/tab_content/${applicantId}`
          }
        }
      }
    }
  }
}
